










import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';

type dataSourceItem = {
    text: string;
    value: string;
}

@Component
export default class Tabs extends Vue {
    @Prop(String) select!: string ;
    @Prop({type: Array}) dataSource!: dataSourceItem[];
    @Prop(String) classPrefix?: string;


    // select = ;//'-'表示支出 '+'表示收入

    selectType(type: dataSourceItem) {
        this.$emit('update:select', type.value);
    }
}
